"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ThemedStyleSheet_1 = __importDefault(require("react-with-styles/lib/ThemedStyleSheet"));
const { colors } = require("@atlaskit/theme");
const aphroditeInterface = require("react-with-styles-interface-aphrodite")
    .default;
const DefaultTheme = require("react-dates/lib/theme/DefaultTheme").default;
const blues = [colors.B75, colors.B100, colors.B200];
const grays = [colors.N50, colors.N100, colors.N300];
ThemedStyleSheet_1.default.registerInterface(aphroditeInterface);
ThemedStyleSheet_1.default.registerTheme({
    reactDates: Object.assign(Object.assign({}, DefaultTheme.reactDates), { border: Object.assign(Object.assign({}, DefaultTheme.reactDates.border), { input: Object.assign(Object.assign({}, DefaultTheme.reactDates.border.input), { border: 0, borderBottomFocused: 0 }) }), color: Object.assign(Object.assign({}, DefaultTheme.reactDates.color), { selectedSpan: {
                backgroundColor: blues[0],
                backgroundColor_active: blues[0],
                backgroundColor_hover: blues[1],
                borderColor: grays[0],
                borderColor_active: grays[1],
                borderColor_hover: grays[2],
                color: colors.N0
            }, hoveredSpan: {
                backgroundColor: blues[0],
                backgroundColor_active: blues[0],
                backgroundColor_hover: blues[1],
                borderColor: grays[0],
                borderColor_active: grays[1],
                borderColor_hover: grays[2],
                color: colors.N0
            }, selected: {
                backgroundColor: blues[2],
                backgroundColor_active: blues[2],
                backgroundColor_hover: blues[2],
                borderColor: grays[0],
                borderColor_active: grays[1],
                borderColor_hover: grays[2],
                color: colors.N0
            } }), spacing: Object.assign(Object.assign({}, DefaultTheme.reactDates.spacing), { displayTextPaddingRight: 0 }), sizing: Object.assign(Object.assign({}, DefaultTheme.reactDates.sizing), { inputWidth: 97, arrowWidth: 30 }), font: Object.assign(Object.assign({}, DefaultTheme.reactDates.font), { input: Object.assign(Object.assign({}, DefaultTheme.reactDates.font.input), { size: 15 }) }) })
});
